import React, { useState } from 'react';
import HeroBanner from '../components/HeroBanner';
import StoreGrid from '../components/StoreGrid';
import CouponCard from '../components/CouponCard';
import HowToUseCoupons from '../components/HowToUseCoupons';
import LatestOffers from '../components/LatestOffers';
import amazon from '../assets/amazon.png';
import nykaa from '../assets/nykaa.png';
import myntra from '../assets/myntra.png';
import flipkart from '../assets/flipkart.png';
import ajio from '../assets/ajio.png';
import cliq from '../assets/cliq.png';
import PopularStores from '../components/PopularStores';
import DealsOfTheDay from '../components/DealsOfTheDay';
import ad5 from '../assets/dellad.webp';
import zouk1 from '../assets/zouknewad.png';
import '../style/Home.css';
import '../style/Modal.css'; 

const coupons = [
  { 
    id: 1, 
    store: 'Amazon', 
    logo: amazon, 
    title: 'Amazon March Mega Sale - Flat 60% OFF on Electronics & Gadgets', 
    code: 'AMZMARCH60', 
    expires: 'Expires in 3 days' 
  },
  { 
    id: 2, 
    store: 'Myntra', 
    logo: myntra, 
    title: 'Myntra Mega March Offers - Extra ₹400 OFF on ₹1999+ Orders', 
    code: 'MYNTRA400', 
    expires: 'Expires in 2 days' 
  },
  { 
    id: 3, 
    store: 'Flipkart', 
    logo: flipkart, 
    title: 'Flipkart Super Saver Week - Flat 70% OFF + Free Shipping', 
    code: 'FLIP70', 
    expires: 'Expires in 5 days' 
  },
  { 
    id: 4, 
    store: 'Ajio', 
    logo: ajio, 
    title: 'AJIO Big Fashion Days - Buy 1 Get 1 Free + Extra ₹300 Off', 
    code: 'AJIOB1G1', 
    expires: 'Expires in 4 days' 
  },
  { 
    id: 5, 
    store: 'Nykaa', 
    logo: nykaa, 
    title: 'Nykaa Beauty Carnival - Free Lipstick + 25% OFF on ₹1499+ Orders', 
    code: 'NYKAAMARCH25', 
    expires: 'Expires in 6 days' 
  },
  { 
    id: 6, 
    store: 'Tata Cliq', 
    logo: cliq, 
    title: 'Tata Cliq Launch Bonanza - Flat 35% Off on Your First Order', 
    code: 'CLIQNEW35', 
    expires: 'Expires in 7 days' 
  },
];


const Home = () => {
  const [selectedCode, setSelectedCode] = useState(null);
  const [copied, setCopied] = useState(false);

  const handleShowCode = (code) => {
    setSelectedCode(code);
  };

  const closeModal = () => {
    setSelectedCode(null);
  };

const copyCode = () => {
  navigator.clipboard.writeText(selectedCode);
  setCopied(true);
  setTimeout(() => setCopied(false), 2000); // revert after 2 seconds
};

  return (
    <>
    <div className='top'>
<h2>India’s Coupons & Deals Marketplace – Save More on Online Shopping</h2>
    </div>
      <HeroBanner />
      <div className="home-container">
        <h2>Top Stores</h2>
        <StoreGrid />
        <PopularStores />
        <h2>Featured Coupons</h2>
        <div className="coupons-grid">
          {coupons.map(coupon => (
            <CouponCard 
              key={coupon.id} 
              {...coupon} 
              onShowCode={handleShowCode} 
            />
          ))}
        </div>

<LatestOffers />


        <div className='ad-image'>

<a href="https://zouk.co.in/collections/backpack-collection?ref=homepage_Slider&utm_source=we24seven&utm_medium=we24seven01">
  <img 
    src={zouk1} 
    alt="zouk ad image" 
    style={{ width: "93%", height: "226px", objectFit: "contain" }}
  />
</a>

<a href="https://seecomparebuy.com/category/featured/">
  <img src= {ad5} alt="ad image 1" 
   style={{ height: "262px" }}
   />
</a>

        </div>
        <DealsOfTheDay />
        <HowToUseCoupons />
              </div>
{selectedCode && (
  <div className="modal-overlay" onClick={closeModal}>
    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
      <button className="close-button" onClick={closeModal}>×</button>
      <h3>Your Coupon Code</h3>
      <div className="code-box">{selectedCode}</div>
      <div className="modal-actions">
        <button className="copy-btn" onClick={copyCode}>
          {copied ? "Copied!" : "Copy Code"}
        </button>
      </div>
    </div>
  </div>
)}
    </>
  );
};

export default Home;
